import MXProductCard from '@c/cards/MXProductCard';
import ProductCardSkeleton from '@c/skeletons/ProductCardSkeleton';
import { useQuery } from '@tanstack/react-query';
import { getProductBySlug } from '@util/firestore/products';

interface MessageProductProps {
  slug: string;
}

export default function MessageProduct({ slug }: MessageProductProps) {
  const { data, isLoading } = useQuery({
    queryKey: ['product', slug],
    queryFn: () =>
      getProductBySlug({ slug: slug.split(' ')[0].replace('.', '') }),
    enabled: !!slug,
  });

  const product = data?.results;

  if (isLoading) return <ProductCardSkeleton />;
  if (!product) return null;

  return (
    <MXProductCard
      product={product}
      attribution={{
        page: 'chat',
        section: 'chat',
        data_source: 'firebase',
      }}
    />
  );
}
